(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/live-region-announcer.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/live-region-announcer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectMaskedOutcomes = svs.components.tipsen.store.reducers.resultModifier.selectors.selectMaskedOutcomes;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const useCountdown = svs.components.poolBetting.hooks.useCountdown;
const useBestBetRows = svs.components.poolBetting.bestBetRows.hooks.useBestBetRows;
function composeLiveMessage(_ref) {
  let draw = _ref.draw,
    isStarted = _ref.isStarted,
    isCancelled = _ref.isCancelled,
    isLive = _ref.isLive,
    isFinalized = _ref.isFinalized,
    countDownString = _ref.countDownString,
    hasMaskedOutcomes = _ref.hasMaskedOutcomes,
    maskedOutcomes = _ref.maskedOutcomes,
    currentWinCount = _ref.currentWinCount,
    formatDate = _ref.formatDate;
  if (!draw) {
    return '';
  }
  if (!isStarted && !isCancelled) {
    const regCloseInfo = countDownString || draw.regCloseTime;
    const date = new Date(regCloseInfo);
    const isValidDate = !isNaN(date);
    const renderDate = isValidDate ? formatDate(regCloseInfo, true, true, false) : regCloseInfo;
    return countDownString ? "Omg\xE5ng startar om ".concat(renderDate) : "Omg\xE5ng startar ".concat(renderDate);
  }
  if (isLive) {
    if (hasMaskedOutcomes) {
      return "Omg\xE5ng p\xE5g\xE5r, r\xE4ttningsupplevelse p\xE5: ".concat(maskedOutcomes.length, " resultat \xE4r dolda, Resultat just nu: ").concat(currentWinCount, " r\xE4tt");
    }
    return "Omg\xE5ng p\xE5g\xE5r, resultat just nu: ".concat(currentWinCount, " r\xE4tt");
  }
  if (isFinalized) {
    if (hasMaskedOutcomes) {
      return "Omg\xE5ng avslutad, r\xE4ttningsupplevelse p\xE5: ".concat(maskedOutcomes.length, " resultat \xE4r dolda, Resultat just nu: ").concat(currentWinCount, " r\xE4tt");
    }
    return "Omg\xE5ng avslutad, resultat: ".concat(currentWinCount, " r\xE4tt");
  }
  return '';
}
const LiveRegionAnnouncer = _ref2 => {
  let draw = _ref2.draw,
    isStarted = _ref2.isStarted,
    isCancelled = _ref2.isCancelled,
    isLive = _ref2.isLive,
    isFinalized = _ref2.isFinalized,
    wagerId = _ref2.wagerId;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    liveMessage = _useState2[0],
    setLiveMessage = _useState2[1];
  const _useBestBetRows = useBestBetRows(),
    hasUnmaskedOutcomes = _useBestBetRows.hasUnmaskedOutcomes,
    hasMaskedOutcomes = _useBestBetRows.hasMaskedOutcomes,
    getBestBetRows = _useBestBetRows.getBestBetRows;
  const _getBestBetRows = getBestBetRows(),
    correctEventCount = _getBestBetRows.correctEventCount;
  const countDownString = useCountdown({
    targetDateTime: draw === null || draw === void 0 ? void 0 : draw.cancelCloseTime
  });
  const maskedOutcomes = useSelector(state => selectMaskedOutcomes(state, wagerId));
  const hasAllOutcomesMasked = hasMaskedOutcomes && !hasUnmaskedOutcomes;
  const currentWinCount = hasAllOutcomesMasked ? '-' : correctEventCount;
  useEffect(() => {
    setLiveMessage(composeLiveMessage({
      draw,
      isStarted,
      isCancelled,
      isLive,
      isFinalized,
      countDownString,
      hasMaskedOutcomes,
      maskedOutcomes,
      currentWinCount,
      formatDate
    }));
  }, [isStarted, isCancelled, countDownString, draw, isLive, isFinalized, hasMaskedOutcomes, maskedOutcomes, currentWinCount]);
  return React.createElement("div", {
    "aria-live": "assertive",
    className: "sr-only"
  }, liveMessage);
};
setGlobal('svs.components.poolBetting.ariaUtils.LiveRegionAnnouncer', LiveRegionAnnouncer);

 })(window);